<template>
  <tela-component title="Relatórios">

    <v-card rounded="" flat class="mb-5" color="transparent">
      <v-card-text class="pt-3 pa-0">
        <v-select
          no-data-text="Nenhum tipo de relatório encontrado"
          hide-details=""
          label="Tipo Relatório"
          :items="tiposRelat"
          item-value="tipo"
          item-text="descricao"
          v-model="tipoSelecModel"
          @change="carregarRelatorios()"
        ></v-select>
      </v-card-text>
    </v-card>

    <template v-if="isMobile()">
      <template v-for="(relat, i) in relatorios">
        <v-list-item :key="i" class="mt-3 white" :to="{ path: relat.rota }">
          <v-list-item-content>
            <v-list-item-title>{{ relat.relatorio }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon><v-icon>mdi-chevron-right</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
      </template>

      <!--
      <v-card
        v-for="(relat, i) in relatorios"
        :key="i"
        rounded="lg"
        flat
        class="mt-2"
      >
        <v-card-title class="subtitle-1" style="write-space: unset">{{
          relat.relatorio
        }}</v-card-title>
        <v-card-subtitle>
          {{ relat.descricao }}
        </v-card-subtitle>
        <v-card-text>
          <v-btn rounded block depressed color="info" :to="{ path: relat.rota }"
            >Executar</v-btn
          >
        </v-card-text>
      </v-card>-->
    </template>
    <v-card flat rounded="lg" v-else>
      <v-card-text>
        <v-data-table
          :search="pesquisa"
          :items="relatorios"
          :headers="headers"
          no-data-text="Nenhum relatório encontrado"
          disable-sort
          :loading="loading"
          no-results-text="Nenhum relatório encontrado"
          loading-text="Aguarde... Carregando relatórios..."
        >
          <template v-slot:top>
            <v-text-field
              v-model="pesquisa"
              placeholder="Pesquisar relatório"
            ></v-text-field>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              small
              rounded
              color="info"
              :to="{ path: item.rota }"
              depressed
              >Executar</v-btn
            >
          </template>
        </v-data-table></v-card-text
      >
    </v-card>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  components: {
    TelaComponent,
  },
  computed: {
    ...mapState("relatorios", ["relatorios", "tipoSelecionado"]),
    ...mapState("usuario", ["usuarioLogado"]),
    tipoSelecModel: {
      get: function () {
        return this.tipoSelecionado;
      },
      set: function (value) {
        this.setTipoSelecionado(value);
      },
    },
  },
  data: () => ({
    loading: true,
    pesquisa: "",
    headers: [
      { text: "Relatório", value: "relatorio" },
      { text: "", value: "actions", align: "end" },
    ],
    tiposRelat: [{ tipo: 1, descricao: "Ração" }],
  }),
  methods: {
    ...mapMutations("relatorios", ["setTipoSelecionado"]),
    ...mapActions("relatorios", ["getRelatorios"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async carregarRelatorios() {
      this.loading = true;
      await this.getRelatorios();
      this.loading = false;
    },
  },
  async mounted() {
    if (this.usuarioLogado.vendedor_coasul) {
      this.tiposRelat.push({ tipo: 2, descricao: "Insumos/Veterinária" });
    }
    await this.carregarRelatorios();
  },
};
</script>

